import { ACTIONS, ROLES, SUBJECTS } from 'features/Permission/constants'
import { ProfileAbilityBuilder, UpdateAbilityContext } from '../types'

export const defineGpoProfileAbilities = (builder: ProfileAbilityBuilder) => {
  const { can } = builder

  can(ACTIONS.ARCHIVE, SUBJECTS.USER)
  can(ACTIONS.EDIT, SUBJECTS.FORM_HOSPITAL_LIST)
}

export const updateGpoAbilities = (
  builder: ProfileAbilityBuilder,
  ctx: UpdateAbilityContext
) => {
  const { can } = builder
  const { user } = ctx

  if (
    user.role === ROLES.GPO_ANALYST ||
    user.role === ROLES.GPO_PRESIDENT ||
    user.role === ROLES.GPO_CONTRACT_STEWARD ||
    user.role === ROLES.GPO_FINANCE_OFFICER
  ) {
    can(ACTIONS.VIEW, SUBJECTS.FINANCIALS)
  }

  if (
    user.role !== ROLES.GPO_ANALYST &&
    user.role !== ROLES.GPO_LEGAL &&
    user.role !== ROLES.GPO_CONTRACT_STEWARD
  ) {
    can(ACTIONS.VIEW, SUBJECTS.MY_COMMUNITY)
  }
}
